import React from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { IS_DESKTOP_SCALE } from "../../../AtomStates";
import gyeongwonLogo from "../../../../assets/images/gyunwonlogo.png";
import backgroundIntroductionModern from "../../../../assets/images/Background/Introduction_modern.png";
import backgroundDeliveryModern from "../../../../assets/images/Background/delivery_modern.png";
import backgroundGuideModern from "../../../../assets/images/Background/guide_modern.png";
import backgroundOpinionModern from "../../../../assets/images/Background/opinion_modern.png";
import backgroundPromotionalModern from "../../../../assets/images/Background/promotional_modern.png";
import backgroundimagetype1 from "../../../../assets/images/Background/B_peach_bloom.png";
import backgroundimagetype2 from "../../../../assets/images/Background/B_lavender_cream.png";
import backgroundimagetype3 from "../../../../assets/images/Background/B_mint_breeze.png";
import backgroundimagetype4 from "../../../../assets/images/Background/B_yellow_moment.png";
import backgroundimagetype5 from "../../../../assets/images/Background/B_classic_bronze.png";
import backgroundimagetype6 from "../../../../assets/images/Background/B_retro_blue.png";
import backgroundimagetype7 from "../../../../assets/images/Background/B_modern_edge.png";
import backgroundimagetype8 from "../../../../assets/images/Background/B_tech_black.png";
import backgroundimagetype9 from "../../../../assets/images/Background/B_fresh_navy.png";
import Markdown from "markdown-to-jsx";
import StreamlinePlumpWeb from "../../../../assets/images/streamline-plump_web.svg";

// 날씨 아이콘 import 추가
import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";

const MoleculeBackgroundSimpleWideLink = ({
  contentsDesignConcept,
  title,
  content,
  weatherData,
  linkUrl,
  onTogglePlay,
}) => {
  const [isDesktopScale] = useAtom(IS_DESKTOP_SCALE);
  console.log("🚀 ~ title:", title);
  console.log("🚀 ~ content:", content);
  console.log("🚀 ~ contentsDesignConcept:", contentsDesignConcept);
  console.log("🌤️ ~ weatherData:", weatherData);

  // 날씨 아이콘 매핑 객체
  const weatherIcons = {
    // 기상청 아이콘
    S10: s10Icon,
    S11: s11Icon,
    S12: s12Icon,
    S13: s13Icon,
    S14: s14Icon,
    S15: s15Icon,
    S16: s16Icon,
    S17: s17Icon,
    S30: s30Icon,
    S31: s31Icon,
    S32: s32Icon,
    S33: s33Icon,
    S34: s34Icon,
    S35: s35Icon,
    S36: s36Icon,
    S37: s37Icon,
    S40: s40Icon,
    S41: s41Icon,
    S42: s42Icon,
    S43: s43Icon,
    S44: s44Icon,
    S45: s45Icon,
    S46: s46Icon,
    S47: s47Icon,

    // OpenWeather 아이콘
    '01d': s10Icon, // 맑음 낮
    '01n': s10Icon, // 맑음 밤
    '02d': s30Icon, // 구름 조금 낮
    '02n': s30Icon, // 구름 조금 밤
    '03d': s40Icon, // 구름 많음 낮
    '03n': s40Icon, // 구름 많음 밤
    '04d': s40Icon, // 구름 매우 많음 낮
    '04n': s40Icon, // 구름 매우 많음 밤
    '09d': s41Icon, // 소나기 낮
    '09n': s41Icon, // 소나기 밤
    '10d': s31Icon, // 비 낮
    '10n': s31Icon, // 비 밤
    '11d': s40Icon, // 뇌우 낮
    '11n': s40Icon, // 뇌우 밤
    '13d': s43Icon, // 눈 낮
    '13n': s43Icon, // 눈 밤
    '50d': s40Icon, // 안개 낮
    '50n': s40Icon, // 안개 밤
  };

  // SKY와 PTY 값을 조합하여 날씨 아이콘 코드 생성
  const getWeatherIconCode = (skyCode, ptyCode) => {
    return `S${skyCode}${ptyCode}`;
  };

  // 아이콘 코드로 실제 아이콘 이미지 가져오기
  const getWeatherIconImage = (iconCode) => {
    return weatherIcons[iconCode] || s30Icon; // 기본값은 S30
  };

  const backgroundImage = () => {
    if (contentsDesignConcept === "concept1") {
      return backgroundimagetype1;
    }

    if (contentsDesignConcept === "concept2") {
      return backgroundimagetype2;
    }

    if (contentsDesignConcept === "concept3") {
      return backgroundimagetype3;
    }

    if (contentsDesignConcept === "concept4") {
      return backgroundimagetype4;
    }

    if (contentsDesignConcept === "concept5") {
      return backgroundimagetype5;
    }

    if (contentsDesignConcept === "concept6") {
      return backgroundimagetype6;
    }

    if (contentsDesignConcept === "concept7") {
      return backgroundimagetype7;
    }

    if (contentsDesignConcept === "concept8") {
      return backgroundimagetype8;
    }

    if (contentsDesignConcept === "concept9") {
      return backgroundimagetype9;
    }

    return backgroundimagetype1;
  };

  const preprocessedContent1 = content[0]
    ? content[0]
        .replace(/<[^>]*>/g, "")
        .replace(/^\n/, "")
        .replace(/\n/g, "<br/>")
    : null;
  const preprocessedContent2 = content[1]
    ? content[1]
        .replace(/<[^>]*>/g, "")
        .replace(/^\n/, "")
        .replace(/\n/g, "<br/>")
    : null;

  // preprocessedContent의 br 태그 개수 계산 (13개 이상이면 타이틀을 한 줄로 표시)
  const content1BrCount = preprocessedContent1 
    ? (preprocessedContent1.match(/<br\/>/g) || []).length
    : 0;
  const content2BrCount = preprocessedContent2
    ? (preprocessedContent2.match(/<br\/>/g) || []).length
    : 0;
  const shouldShowTitleInOneLine = content1BrCount >= 13 || content2BrCount >= 13;

   // ==== 날짜/시간/날씨 유틸 ==== 
   const daysKOR = ["일", "월", "화", "수", "목", "금", "토"]; 
   const formatKoreanDate = (d) => { 
     const m = d.getMonth() + 1; 
     const day = d.getDate(); 
     const wd = daysKOR[d.getDay()]; 
     return `${m}월 ${day}일 (${wd})`; 
   }; 
   const formatKoreanTime = (d) => { 
     const h = d.getHours(); 
     const min = d.getMinutes(); 
     const isPM = h >= 12; 
     const hh = (h % 12 || 12).toString().padStart(2, "0"); 
     const mm = min.toString().padStart(2, "0"); 
     return `${isPM ? "오후" : "오전"} ${hh}:${mm}`; 
   }; 
  
   const [now, setNow] = React.useState(new Date()); 
   const [tempC, setTempC] = React.useState(null);

   // 날씨 데이터가 있으면 우선 사용, 없으면 API 호출
   React.useEffect(() => {
     if (weatherData && weatherData.temperature) {
       setTempC(parseFloat(weatherData.temperature));
     }
   }, [weatherData]); 
  
   // 시계: 1분마다 갱신 
   React.useEffect(() => { 
     const id = setInterval(() => setNow(new Date()), 60 * 1000); 
     return () => clearInterval(id); 
   }, []); 

  return (
    <StyledMainContainer
      backgroundImage={backgroundImage()}
      isDesktopScale={isDesktopScale}
    >
      {/* 메인 컨텐츠 프레임 */}
      <StyledMainContentFrame contentsDesignConcept={contentsDesignConcept}>
        <StyledHeaderSection>
          {/* 타이틀 영역 */}
          <StyledTitleContainer>
            {title.length > 0 && (
              <StyledTitleText>
                {shouldShowTitleInOneLine 
                  ? `${title[0]} ${title[1] || ''}`.trim()
                  : (
                    <>
                      {title[0]}
                      <br />
                      {title[1]}
                    </>
                  )
                }
              </StyledTitleText>
            )}
          </StyledTitleContainer>

          {/* 로고 영역 - 기존 PNG 이미지 사용 */}
          <StyledLogoArea shouldShowTitleInOneLine={shouldShowTitleInOneLine}>
            <StyledLogoImage src={gyeongwonLogo} alt="경원중학교 로고" />
            {/* ▼ 로고 아래 날짜/시간/온도 */}
            <RightInfoWrap shouldShowInOneLine={shouldShowTitleInOneLine}>
            {shouldShowTitleInOneLine ? (
              /* 한 줄로 표시 */
              <>
                <DateText>{formatKoreanDate(now)}</DateText>
                <TimeText>{formatKoreanTime(now)}</TimeText>
                {/* 날씨 아이콘 표시 */}
                {weatherData && weatherData.sky && weatherData.pty ? (
                  <WeatherIconImg 
                    src={getWeatherIconImage(getWeatherIconCode(weatherData.sky, weatherData.pty))} 
                    alt="날씨" 
                  />
                ) : (
                  weatherData && weatherData.icon ? (
                  <WeatherIconImg 
                    src={getWeatherIconImage(weatherData.icon)} 
                    alt="날씨" 
                  />
                  ) : (
                  <IconSlot aria-hidden />
                  )
                )}
                <TempText>온도 {tempC == null ? "—" : tempC}°</TempText>
              </>
            ) : (
              /* 기존 방식: 세로로 표시 */
              <>
                <DateText>{formatKoreanDate(now)}</DateText>
                <RowRight>
                  <TimeText>{formatKoreanTime(now)}</TimeText>
                </RowRight>
                <RowRight>
                  {/* 날씨 아이콘 표시 */}
                {weatherData && weatherData.sky && weatherData.pty ? (
                  <WeatherIconImg 
                    src={getWeatherIconImage(getWeatherIconCode(weatherData.sky, weatherData.pty))} 
                    alt="날씨" 
                  />
                ) : (
                  weatherData && weatherData.icon ? (
                  <WeatherIconImg 
                    src={getWeatherIconImage(weatherData.icon)} 
                    alt="날씨" 
                  />
                  ) : (
                  <IconSlot aria-hidden />
                  )
                )}
                  <TempText>온도 {tempC == null ? "—" : tempC}°</TempText>
                </RowRight>
              </>
            )}
            </RightInfoWrap>
          </StyledLogoArea>
        </StyledHeaderSection>

        {/* 컨텐츠 메인 섹션 */}
        <StyledContentMainSection>
          <StyledContentWrapper>
            <StyledColumn1>
              {preprocessedContent1 && (
                <StyledSectionContent
                  as="div"
                  style={{ width: "100%", whiteSpace: "pre-wrap" }}
                >
                  <Markdown>{preprocessedContent1}</Markdown>
                </StyledSectionContent>
              )}
            </StyledColumn1>
            <StyledColumn2>
              {preprocessedContent2 && (
                <StyledSectionContent
                  as="div"
                  style={{ width: "100%", whiteSpace: "pre-wrap" }}
                >
                  <Markdown>{preprocessedContent2}</Markdown>
                </StyledSectionContent>
              )}
            </StyledColumn2>
          </StyledContentWrapper>

          {/* 우측 하단 고정 버튼 */}
          {linkUrl && (
            <StyledBottomRightButton>
              <StyledLinkButton
                onClick={() => {
                  if (onTogglePlay) onTogglePlay();
                  if (linkUrl) window.open(linkUrl, '_blank');
                }}
                aria-label="페이지 이동"
              >
                <StyledLinkIcon src={StreamlinePlumpWeb} alt="링크" />
                <StyledLinkText>{linkUrl}</StyledLinkText>
                <StyledBlueButton>
                  <StyledButtonText>페이지 이동</StyledButtonText>
                  <StyledArrowIcon>›</StyledArrowIcon>
                </StyledBlueButton>
              </StyledLinkButton>
            </StyledBottomRightButton>
          )}
        </StyledContentMainSection>
      </StyledMainContentFrame>
    </StyledMainContainer>
  );
};

export default MoleculeBackgroundSimpleWideLink;

// 메인 컨테이너 - 1920x1080 크기로 배경 이미지 지원
const StyledMainContainer = styled.div`
  padding: 140px 190px 140px 190px;
  width: 3840px;
  height: 2160px;
  background: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : "white"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
`;

// 메인 컨텐츠 프레임 - HTML과 동일한 위치와 크기
const StyledMainContentFrame = styled.div`
  padding: 80px;
  width: 100%; /* calc(1920 * 0.9) */
  height: 100%; /* calc(1080 * 0.867) */
  background: rgba(255, 255, 255, 0.95);

  box-shadow: ${(props) =>
    props.contentsDesignConcept === "concept5" ||
    props.contentsDesignConcept === "concept6" ||
    props.contentsDesignConcept === "concept7" ||
    props.contentsDesignConcept === "concept8" ||
    props.contentsDesignConcept === "concept9"
      ? "none"
      : "0px 4px 32px rgba(0, 0, 0, 0.12)"};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 80px; /* calc(1080 * 0.037) */
`;

// 헤더 섹션
const StyledHeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

// 타이틀 컨테이너
const StyledTitleContainer = styled.div`
  flex: 1;
  text-align: left;
`;

// 타이틀 스타일
const StyledTitleText = styled.div`
  color: #323232;
  font-size: 160px; /* calc(1920 * 0.0417) */
  font-family: Pretendard;
  font-weight: 800;
  line-height: 1.35; /* 108px/80px = 1.35 */
  word-wrap: break-word;
  white-space: pre-line;
`;

// 로고 영역
const StyledLogoArea = styled.div`
  width: 500px; /* calc(1920 * 0.130) */
  height: ${props => props.shouldShowTitleInOneLine ? '300px' : '432px'}; /* calc(1080 * 0.056) */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
`;

const StyledLogoImage = styled.img`
  max-width: 400px;
  max-height: 90px;
  object-fit: contain;
`;

// 컨텐츠 메인 섹션
const StyledContentMainSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 64px; /* calc(1080 * 0.03) */
  position: relative;
  flex: 1;
`;

// 우측 하단 고정 버튼 영역
const StyledBottomRightButton = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

// 컨텐츠 컨테이너
const StyledContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 40px; /* calc(1080 * 0.0185) */
`;

// 메인 설명 텍스트
const StyledMainDescription = styled.div`
  color: black;
  font-size: 64px; /* calc(1920 * 0.0167) */
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.5; /* 96px/64px = 1.5 */
  word-wrap: break-word;
  text-align: start;
`;

// 메인 컨테이너 프레임 (600px 고정)
const StyledMainContent = styled.div`
  width: 100%;
  height: 1200px; /* calc(1080 * 0.556) */
  justify-content: flex-start;
  align-items: center;
  gap: 64px; /* calc(1920 * 0.0167) */
  display: inline-flex;
`;

// 두 컬럼 래퍼
const StyledContentWrapper = styled.div`
  width: 3216px; /* calc(1920 * 0.838) */
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
`;

// 첫 번째 컬럼
const StyledColumn1 = styled.div`
  width: 1576px; /* calc(1920 * 0.410) */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 56px; /* calc(1080 * 0.026) */
  display: inline-flex;
`;

// 두 번째 컬럼 - 높이를 줄여서 버튼 공간 확보
const StyledColumn2 = styled.div`
  width: 1576px; /* calc(1920 * 0.410) */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 64px; /* calc(1080 * 0.030) */
  display: inline-flex;
  height: auto;
`;

// 개별 섹션 컨테이너들
const StyledSectionContainer = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px; /* calc(1080 * 0.004) */
  display: flex;
`;

const StyledSection1 = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const StyledSection2 = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const StyledSection3 = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const StyledSection4 = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

// 섹션 제목 스타일
const StyledSectionTitle = styled.div`
  color: #323232;
  font-size: 64px; /* calc(1920 * 0.0167) */
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.5; /* 96px/64px = 1.5 */
  word-wrap: break-word;
`;

// 섹션 내용 스타일
const StyledSectionContent = styled.div`
  color: #323232;
  font-size: 64px; /* calc(1920 * 0.0167) */
  font-family: Pretendard;
  font-weight: 400;
  line-height: 1.5; /* 96px/64px = 1.5 */
  word-wrap: break-word;
  text-align: start;
`;

const RightInfoWrap = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: ${props => props.shouldShowInOneLine ? 'row' : 'column'};
  align-items: ${props => props.shouldShowInOneLine ? 'center' : 'flex-end'};
  justify-content: ${props => props.shouldShowInOneLine ? 'flex-end' : 'flex-start'};
  gap: ${props => props.shouldShowInOneLine ? '28px' : '16px'};
`;

const RowRight = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 24px;
`;

const DateText = styled.span`
  color: #323232;
  font-size: 64px;
  font-family: Pretendard, system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Apple SD Gothic Neo", sans-serif;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
`;

const TimeText = styled.span`
  color: #323232;
  font-size: 64px;
  font-family: Pretendard, system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Apple SD Gothic Neo", sans-serif;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
`;

const TempText = styled.span`
  color: #323232;
  font-size: 64px;
  font-family: Pretendard, system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Apple SD Gothic Neo", sans-serif;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
`;

const IconSlot = styled.div`
  width: 72px;
  height: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 48px; /* 이모지 크기 조정 */
  /* 나중에 SVG/이미지 컴포넌트 넣을 자리 */
`;

// 날씨 아이콘 이미지 컴포넌트
const WeatherIconImg = styled.img`
  width: 72px;
  height: 72px;
  object-fit: contain;
`;

// 링크 버튼 컴포넌트
const StyledLinkButton = styled.button`
  height: 148px;
  padding: 36px 48px;
  background: white;
  border-radius: 20px;
  border: 2px solid #E0E4EB;
  display: flex;
  align-items: center;
  gap: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: auto;

  &:hover {
    background: #F8F9FB;
    border-color: #226FFF;
    transform: translateY(-2px);
    box-shadow: 0px 8px 24px rgba(34, 111, 255, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

const StyledLinkIcon = styled.img`
  width: 72px;
  height: 72px;
  object-fit: contain;
  flex-shrink: 0;
`;

const StyledLinkText = styled.span`
  color: #323232;
  font-size: 52px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 800px;
  flex: 1;
  text-align: left;
`;

const StyledBlueButton = styled.div`
  display: flex;
  align-items: center;
  background: #226FFF;
  padding: 16px 35px;
  border-radius: 12px;
  gap: 25px;
  flex-shrink: 0;
`;

const StyledButtonText = styled.span`
  color: white;
  font-size: 45px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
`;

const StyledArrowIcon = styled.span`
  color: white;
  font-size: 56px;
  font-weight: 300;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;


// HTML 구조를 따르는 예시 컴포넌트
export const ContentExampleSimpleWidth = () => {
  return (
    <StyledContentContainer>
      <StyledMainContent>
        <StyledContentWrapper>
          {/* 첫 번째 컬럼 */}
          <StyledColumn1>
            {/* 일시 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>일시</StyledSectionTitle>
              <StyledSectionContent>
                2025년 5월 23일(금)
                <br />
                15:20 ~ 16:10 (50분)
              </StyledSectionContent>
            </StyledSectionContainer>

            {/* 신청 기한 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>신청 기한</StyledSectionTitle>
              <StyledSectionContent>
                2025년 5월 14일(수) ~ 16일(금)
                <br />
                12:00 까지
              </StyledSectionContent>
            </StyledSectionContainer>

            {/* 신청 방법 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>신청 방법</StyledSectionTitle>
              <StyledSectionContent>
                구글 신청서 제출 (경원중 계정으로 로그인)
                <br />
                http://mmmmmm
              </StyledSectionContent>
            </StyledSectionContainer>
          </StyledColumn1>

          {/* 두 번째 컬럼 */}
          <StyledColumn2>
            {/* 대회 장소 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>대회 장소</StyledSectionTitle>
              <StyledSectionContent>
                1학년 : 3학년 1반 교실
                <br />
                2학년 : 3학년 2반 교실
                <br />
                3학년 : 3학년 3반 교실
              </StyledSectionContent>
            </StyledSectionContainer>

            {/* 논술 주제 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>논술 주제</StyledSectionTitle>
              <StyledSectionContent>
                당일 현장 공개
                <br />
                필기도구(연필, 샤프, 지우개 등) 준비 필요
              </StyledSectionContent>
            </StyledSectionContainer>

            {/* 수상 인원 섹션 */}
            <StyledSectionContainer>
              <StyledSectionTitle>수상 인원</StyledSectionTitle>
              <StyledSectionContent>
                학년별 시상, 학년별 참가 인원의 20% 이내
              </StyledSectionContent>
            </StyledSectionContainer>
          </StyledColumn2>
        </StyledContentWrapper>
      </StyledMainContent>
    </StyledContentContainer>
  );
};

// 기존 호환성을 위한 단순 예시 컴포넌트
export const ContentExample = () => {
  return (
    <StyledContentContainer>
      <StyledMainDescription>
        교내 논술대회에 많은 참여 부탁드립니다.
      </StyledMainDescription>
      <div style={{ display: "flex", gap: "32px", marginTop: "20px" }}>
        <StyledSectionTitle>일시</StyledSectionTitle>
        <StyledSectionContent>
          2025년 5월 23일(금)
          <br />
          15:20 ~ 16:10 (50분)
        </StyledSectionContent>
      </div>
    </StyledContentContainer>
  );
};
